function filter(width) {

    var screenWidth = $(window).width(),
        filter      = $('#_js-filter'),
        workarea    = $('#_workarea'),
        desktop     = $('#_js-filter-desktop');

    if ( screenWidth <= width && desktop.find(filter).length ) {
        workarea.append(filter);
    } else if( screenWidth > width && workarea.find(filter).length ) {
        desktop.append(filter);
    }
	
}

function initFilter() {
	$('body').on('click', '#_js-filter a:not(.js-filter-show)', function (e) { e.preventDefault(); $(this).parent().click(); });
	$('body').on('click', '#_js-filter input[type="radio"]', function () { 
		if ($(this).data('checked') == 1) {
			$(this).prop('checked', false); 
			$(this).data('checked', 0);
		} else {
			$(this).data('checked', 1);
			$(this).closest('.filter__section').find('input').not(this).data('checked',0);
		}
	
	});
	
	$('body').on('change', '#_js-filter input[type="checkbox"]', function () { 
		if ($(this).prop('checked')) {
			$(this).closest('.filter__section').find('input').not(this).prop('checked',false);
		}
	
	});
	
	$('body').on('change click', '#_js-filter input', function () {
		$('#modef').css('top', $(this).closest('.filter__section').position().top + 10 + 'px');
	});
	
	$('body').on('click', '#_js-mob-filter-start', function () {
		$('#modef a').click();
	});
}

function toggleFilter() {

    var open    = $('._js-filter-open'),
        close   = $('._js-filter-close'),
        wrapper = $('.website-wrapper');

    open.on('click', function(){
        if ( !wrapper.hasClass('_filter-active') ) {
            wrapper.addClass('_filter-active');
        } else {
            wrapper.removeClass('_filter-active');
        }

    });

    close.on('click', function(){
        if ( wrapper.hasClass('_filter-active') ) {
            wrapper.removeClass('_filter-active');
        }
    });

    $(document).on('mouseup touchend', function(e){
        if (!$('._js-filter').is(e.target) && $('._js-filter').has(e.target).length === 0) {
            wrapper.removeClass('_filter-active');
        }
    });

}